"use client";

import clsx from "clsx";

import type { HeroCardStoryblok } from "@/types/blok-types";

import styles from "./hero-slider.module.css";
import useHeroSlider from "./useHeroSlider";

const Slider = ({
  children,
  media,
}: {
  children: React.ReactNode;
  media: HeroCardStoryblok[];
}): React.JSX.Element => {
  const { emblaRef, scrollTo, scrollSnaps, selectedIndex } = useHeroSlider({
    images: media,
  });
  return (
    <div className={styles.embla} ref={emblaRef}>
      <div className={styles.embla__container}>{children}</div>
      <nav className={styles.dot__gallery}>
        {scrollSnaps.length > 1 &&
          scrollSnaps.map((_, index) => (
            <button
              className={clsx(
                styles["dot-button"],
                index === selectedIndex && styles["is-selected"]
              )}
              key={index}
              onClick={() => scrollTo(index)}
            >
              <span className={styles.dot} />
            </button>
          ))}
      </nav>
    </div>
  );
};

export default Slider;
